<template>
    <v-form
        ref="form"
        lazy-validation
    >
        <v-row>
            <v-col cols="12" sm="6" md="6">
                <v-text-field
                    v-model="agency"
                    label="Agency Name"
                    :rules='requiredField'
                ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
                <v-select
                    v-model="type"
                    label="Garnishment Type"
                    :items="types"
                    :rules='requiredField'
                ></v-select>
            </v-col>
            <v-col cols="12">
                <h3>Payment Information</h3>
                <v-divider></v-divider>
            </v-col>
            <v-col cols="12" sm="6" md="4">
                <v-text-field
                    v-model="account"
                    label="Case/Account Number"
                    :rules='requiredField'
                ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
                <v-text-field
                    v-model="additional"
                    label="Additional Number"
                    :rules='requiredField'
                ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
                <v-menu
                    ref="menu1"
                    v-model="menu1"
                    :close-on-content-click="true"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                >
                <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-model="courtDate"
                        label="Court Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        :rules='requiredField'
                    ></v-text-field>
                </template>
                <v-date-picker
                    v-model="courtDate"
                    no-title
                    scrollable
                >
                </v-date-picker>
                </v-menu>
            </v-col>
            <v-col cols="12" md="4" class="pa-2">
                <v-text-field
                    v-model="plaintiff"
                    label="Plaintiff Name"
                    :rules='requiredField'
                ></v-text-field>
            </v-col>
            <v-col cols="6" md="4" class="pa-2">
                <v-text-field
                    v-model="recipient"
                    label="Recipient Name"
                    :rules='requiredField'
                ></v-text-field>
            </v-col>
            <v-col cols="6" md="4" class="pa-2">
                <v-text-field
                    v-model="amount"
                    label="Amount"
                    :rules='requiredField'
                ></v-text-field>
            </v-col>
            <v-col cols="12">
                <v-textarea
                    outlined
                    v-model="notes"
                    label="Notes"
                    :rules='requiredField'
                ></v-textarea>
            </v-col>
            <v-col cols="12" sm="12" md="12">
                <form enctype="multipart/form-data">
                    <v-file-input
                        v-model="document"
                        class="pa-2"
                        label="Garnishment Document"
                        filled
                        multiple
                        prepend-icon="mdi-camera"
                        accept="image/*, .pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                        @change="fileSelected"
                        show-size
                        :rules='requiredField'
                    >
                        <template #selection="{ text, index }">
                            <v-chip
                                small
                                label
                                close
                                color="primary"
                                @click:close="deleteChip(index)"
                            >
                                {{ text }}
                            </v-chip
                        >
                        </template>
                    </v-file-input>
                </form>
                <!-- <v-row>
                    <v-col
                        cols="12"
                        sm="12"
                        md="12"
                        v-for="doc in document"
                        :key="doc.id"
                    >
                        <div v-if="doc.ext != 'pdf'">
                        <v-img
                            max-height="480"
                            max-width="550"
                            :src="doc.aws"
                        ></v-img>
                        </div>
                        <div v-if="doc.ext == 'pdf'">
                        <load-pdf :pdfFile="doc.aws" :pdfName="doc.name" />
                        </div>
                    </v-col>
                </v-row> -->
            </v-col>
            <v-col cols="6" sm="6" md="6">
                <span>Status</span>
                <v-switch
                    v-model="status"
                    :label="status ? 'Active' : 'Inactive'"
                ></v-switch>
            </v-col>
            <v-col class="py-0" cols="12">
                <v-card-actions class="pt-0">
                    <v-spacer></v-spacer>
                    <v-btn
                        text
                        color="green darken-2"
                        icon
                        dark
                        @click="saveEditedPayrollReport(tabItems)"
                        :loading="isSavingEditLoading"
                        :disabled="isSavingEditLoading"
                    >
                        <v-icon>mdi-content-save</v-icon>
                    </v-btn>
                </v-card-actions>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>

import {mapState, mapMutations, mapActions} from "vuex";
import renameFileHelper from "@/mixins/renameFileHelper";

export default {
    mixins: [renameFileHelper],

    props: {
        tabItems: Object,
    },

    data () {
        return {
            date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                .toISOString()
                .substr(0, 10),
            menu1: false,
            itemId: "",

            agency: "",
            type: "",
            account: "",
            additional: "",
            courtDate: "",
            plaintiff: "",
            recipient: "",
            amount: "",
            notes: "",
            document: null,
            status: "Active",

            types: ["Child Support", "Collections", "Office of Recovery Services"],

            requiredField: [
                v => !!v || 'This field is required',
            ],

            isSavingEditLoading: false,
        }
    },

    computed: {
        ...mapState("garnishments", ["uploadFileItems"]),

        ...mapState({
            selectedUserPayrollReport: state => state.payrollReportsHistories.selectedUserPayrollReport,
        }),

        staffName() {
            // `this` points to the component instance
            return this.$store.state.staff.staff.Name;
        },
    },
    
    methods: {
        ...mapMutations ({
            setSelectedDeductPanel: "payrollReportsHistories/setSelectedDeductPanel",
        }),
        ...mapActions("garnishments", [
            "addItem",
            "uploadItem",
        ]),

        async fileSelected(e) {
            try {
                const files = await this.renameFileHelper(
                    e,
                    this.staffName,
                    "Garnishment",
                    this.courtDate
                );
                files.forEach((file) => this.addUploadFile(file));
            } catch (error) {
                this.errorMsg("adding", "file", error);
            }
        },

        addUploadFile(file) {
            this.$store.commit("garnishments/ADD_UPLOAD_FILE", file);
        },

        deleteChip(index) {
            this.document.splice(index, 1);
        },

        saveFile() {
            if (this.uploadFileItems.length === 0) return;
            this.uploadFileItems.forEach((file) => {
                this.uploadItem({
                    file,
                    id: this.itemId,
                    userId: this.selectedUserPayrollReport._id,
                });
            });
        },

        async saveEditedPayrollReport (tabItems) {
            this.isSavingEditLoading = true;

            if (this.$refs.form.validate()) {
                try {
                    const d = new Date(Date.now());
                    const newDate = new Date(this.courtDate);

                    newDate.setHours(d.getHours())
                    newDate.setMinutes(d.getMinutes())
                    newDate.setSeconds(d.getSeconds())
                    newDate.setMilliseconds(d.getMilliseconds())

                    const data = {
                        Agency: this.agency,
                        Type: this.type,
                        Account: this.account,
                        Additional: this.additional,
                        CourtDate: newDate.toISOString(),
                        Plaintiff: this.plaintiff,
                        Recipient: this.recipient,
                        Notes: this.notes,
                        Amount: this.amount,
                        Status: this.status,
                        StaffID: this.selectedUserPayrollReport._id,
                    };

                    const response = await this.addItem(data);

                    if (response.status === 201) {
                        tabItems.itemValue = parseFloat(data.Amount);
                        tabItems.isEdit = false;

                        this.agency = "";
                        this.type = "";
                        this.account = "";
                        this.additional = "";
                        this.courtDate = "";
                        this.plaintiff = "";
                        this.recipient = "";
                        this.amount = "";
                        this.notes = "";
                        this.document = null;

                        let snackbarMsg = {
                            saveEditedPayrollReport_snackbarText: "New garnishment has been added successfully.",
                            saveEditedPayrollReport_snackbarColor: "success",
                            saveEditedPayrollReport_snackbar: true,
                        }

                        this.$emit("snackbarMsg", snackbarMsg);

                        this.setSelectedDeductPanel(null);

                        this.itemId = response.data.results._id;
                        this.saveFile();
                    }
                } catch (error) {
                    this.errorMsg("adding", "record", error);
                } finally {
                    this.isSavingEditLoading = false;
                }
            } else {
                let snackbarMsg = {
                    saveEditedPayrollReport_snackbarText: "Please fill out all required fields.",
                    saveEditedPayrollReport_snackbarColor: "error",
                    saveEditedPayrollReport_snackbar: true,
                }

                this.$emit("snackbarMsg", snackbarMsg)

                this.isSavingEditLoading = false;
            }
        },

        errorMsg(action, item, error) {
            console.error(`An error occured whiling ${action} ${item}`, error);
        },

    }
}
</script>